import { useSocketClient } from '@talos/kyoko';
import { useEffect } from 'react';
import { useFeatureFlag } from '../hooks/useFeatureFlag';
import { CM_WEBSOCKET_CLIENT_KEY } from './CoinMetricsApiProvider/coinMetricsConstants';

/**
 * Syncs the ui.BlockSubscriptions feature flag value onto every WebSocket client's blocked-subscriptions
 * list — the primary Talos client AND any named client registered via `useRegisterSocketClient` (today,
 * the CoinMetrics client). Named clients enforce the same block list (see
 * `CoinMetricsWebSocketClient.registerSubscription`), but they don't receive it unless it's pushed here:
 * the no-key `useSocketClient()` only resolves the Talos client, so without the keyed sync below an org
 * using ui.BlockSubscriptions to disable a problematic stream would still see it connect on CoinMetrics.
 */
export function BlockedSubscriptionsSyncer() {
  const client = useSocketClient();
  // Registered asynchronously once the CoinMetrics API key is available, so this is null on the first
  // renders — the effect re-runs (and syncs) the moment it appears.
  const coinMetricsClient = useSocketClient(CM_WEBSOCKET_CLIENT_KEY);
  const { blockedSubscriptions } = useFeatureFlag();

  useEffect(() => {
    const blocked = new Set(blockedSubscriptions);

    if (client != null) {
      client.setBlockedSubscriptions(blocked);
    }
    if (coinMetricsClient != null) {
      coinMetricsClient.setBlockedSubscriptions(blocked);
    }
  }, [client, coinMetricsClient, blockedSubscriptions]);

  return null;
}
